import { Injectable } from '@angular/core';
import { GoalsModel, GoalTasksModel, UpdateTaskModel } from '../models/goals.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoalService {

  goalsController = '/api/StudentGoals'

  constructor(private _http: HttpClient) { }

  getAllStudentGoals(): Observable<GoalsModel[]>
  {
    return this._http.get<GoalsModel[]>(`${this.goalsController}/GetAllStudentGoals`);
  }

  updateTaskCompletion(updateTask: UpdateTaskModel): Observable<any>
  {
    return this._http.put<any>(`${this.goalsController}/UpdateTaskCompletion`, updateTask)
  }

  updateStudentGoal(studentGoalId:number, studentGoal: GoalsModel): Observable<any>
  {
    return this._http.put<any>(`${this.goalsController}/UpdateStudentGoal/${studentGoalId}`, studentGoal)
  }

  createStudentGoal(goalModel: GoalsModel): Observable<any>
  {
    return this._http.post<any>(`${this.goalsController}/CreateStudentGoal`, goalModel);
  }

  deleteStudentGoal(studentGoalId: number): Observable<any>
  {
    return this._http.delete<any>(`${this.goalsController}/DeleteStudentGoal/${studentGoalId}`);
  }
}
